import { Tooltip } from 'react-tooltip';

export const ToolbarTooltips = () => {
  return (
    <>
      <Tooltip
        anchorSelect="#element-tree-icon"
        place="right"
        content="Element Tree"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#assets-icon"
        place="right"
        content="Assets"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#window-icon"
        place="right"
        content="Window"
        delayShow={500}
      />

      <Tooltip
        anchorSelect="#add-box-icon"
        place="right"
        content="Add Box Element"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#add-button-icon"
        place="right"
        content="Add Button Element"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#add-text-icon"
        place="right"
        content="Add Text Element"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#add-link-icon"
        place="right"
        content="Add Hyperlink Text Element"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#add-variable-icon"
        place="right"
        content="Add Variable Text Element"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#add-img-icon"
        place="right"
        content="Add Image Element"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#add-progressbar-icon"
        place="right"
        content="Add Progressbar Element"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#add-iframe-icon"
        place="right"
        content="Add IFrame Element"
        delayShow={500}
      />

      <Tooltip
        anchorSelect="#feedback-icon"
        place="right"
        content="Send Feedback"
        delayShow={500}
      />
      <Tooltip
        anchorSelect="#toggle-theme-icon"
        place="right"
        content="Toggle Theme"
        delayShow={500}
      />
    </>
  );
};
